export default __webpack_public_path__ + "static/media/Pulse Rate disabled.c710b751.svg";